import { Box, Typography } from "@mui/material";
import React from "react";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

interface ItemProps {
  text: string;
}

const IdentityBulletItem: React.FC<ItemProps> = ({ text }) => {
  return (
    <Box>
      <RadioButtonUncheckedIcon color="warning" sx={{ fontSize: 12, mr: 1 }} />
      <Typography variant="caption">{text}</Typography>
    </Box>
  );
};

export default IdentityBulletItem;
